import React, { useMemo } from 'react';
import GenericTableFilter from '../../../../../components/common/GenericTableFilter';
import DealerDropdown from '../../../../../components/common/DealerDropdownWithMulti';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const InvoiceApprovalHistoryFilter = ({ handleApplyFilters, handleResetFilters }) => {
    const { th } = useLanguage();

    const defaultDates = useMemo(() => {
        const now = new Date();
        return {
            startDate: new Date(now.getFullYear(), now.getMonth(), 1),
            endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0)
        };
    }, []);

    const filterFields = useMemo(() => [
        {
            field: 'dealer',
            headerName: th('invoiceApproval.filters.dealer'),
            type: 'custom',
            customComponent: ({ value, onChange }) => (
                <DealerDropdown
                    multiple
                    showSelectAll
                    value={value}
                    onChange={onChange}
                    className="w-full"
                    selectedItemsLabel={th('invoiceApproval.filters.selectedItems')}
                />
            )
        },
        {
            field: 'chassisNo',
            headerName: th('invoiceApproval.detailModal.chassisNo'),
            type: 'text',
            filterPlaceholder: th('invoiceApproval.history.filterChassisPlaceholder') || 'Åasi no ara...'
        },
        {
            field: 'dmsOrderNumber',
            headerName: th('invoiceApproval.history.dmsOrderNumber'),
            type: 'text',
            filterPlaceholder: th('invoiceApproval.history.filterDmsOrderPlaceholder') || 'DMS SipariÅŸ No ara...'
        },
        {
            field: 'startDate',
            headerName: th('invoiceApproval.filters.startDate'),
            type: 'date'
        },
        {
            field: 'endDate',
            headerName: th('invoiceApproval.filters.endDate'),
            type: 'date'
        }
    ], [th]);

    const customFilterTypes = useMemo(() => ({
        dealer: 'custom',
        chassisNo: 'text',
        dmsOrderNumber: 'text',
        startDate: 'date',
        endDate: 'date'
    }), []);

    return (
        <div className="mb-2">
            <GenericTableFilter
                filterFields={filterFields}
                customFilterTypes={customFilterTypes}
                onApplyFilters={handleApplyFilters}
                onResetFilters={handleResetFilters}
                initialFilters={defaultDates}
                initiallyOpen={true}
            />
        </div>
    );
};

export default InvoiceApprovalHistoryFilter;